import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SessionUser } from 'src/shared/session';

import { AUTHENTICATION_EDIT_PUBLISHED_PETITION_ERROR, EDIT_PUBLISHED_PETITION_ERROR } from './constants';
import type {
	EditPublishedPetitionV2Mutation,
	EditPublishedPetitionV2MutationVariables,
} from './editPublishedPetition.graphql';
import { EditPublishedPetitionV2 } from './editPublishedPetition.graphql';
import type { PetitionInput, PetitionResponse } from './types';

type Params = { petitionInput: PetitionInput; user?: SessionUser };

export async function editPublishedPetition(
	{ petitionInput, user }: Params,
	{ gql: { fetch }, errorReporter }: UtilityContext,
): Promise<PetitionResponse> {
	if (!user) throw new Error(AUTHENTICATION_EDIT_PUBLISHED_PETITION_ERROR);
	try {
		const { data } = await fetch<EditPublishedPetitionV2Mutation, EditPublishedPetitionV2MutationVariables>({
			query: EditPublishedPetitionV2,
			variables: {
				input: petitionInput,
			},
			rejectOnError: true,
		});

		const result = data.editPublishedPetition;
		if (result.__typename !== 'EditPublishedPetitionSuccess') throw new Error(EDIT_PUBLISHED_PETITION_ERROR);
		if (!result.success) throw new Error(EDIT_PUBLISHED_PETITION_ERROR);

		return result;
	} catch (err) {
		void errorReporter.report(new Error('Failed to save petition', { cause: err }));
		const unknownError = err instanceof Error ? err : new Error(EDIT_PUBLISHED_PETITION_ERROR);
		throw unknownError;
	}
}
